// Admin user ID for Mekomit admin dashboard
export const ADMIN_USER_ID = '105091406440278934663';

/**
 * Check if the given user ID is an admin
 * @param {string} userId - The user ID to check
 * @returns {boolean} - True if user is admin
 */
export const isAdmin = (userId) => {
  return userId === ADMIN_USER_ID;
};

/**
 * Verify admin access and throw error if not admin
 * @param {string} userId - The user ID to check
 * @throws {Error} - If user is not admin
 */
export const requireAdmin = (userId) => {
  if (!isAdmin(userId)) {
    throw new Error('Unauthorized: Admin access required');
  }
};
